export default {
    mission: {
        ignore: true
    },
    manager: {
        ignore: true
    },
    orientation: {
        options: [
            { value: '', label: 'Any orientation' },
            { value: 'LANDSCAPE', label: 'Landscape' },
            { value: 'PORTRAIT', label: 'Portrait' },
            { value: 'SQUARE', label: 'Square' }
        ]
    },
    license: {
        options: [
            { value: '', label: 'Any license' },
            { value: 'commercial', label: 'Commercial' },
            { value: 'editorial', label: 'Editorial' }
        ]
    },
    size: {
        options: [
            { value: '', label: 'Any size' },
            //{ value: '2', label: '2 MP and larger' },
            { value: '4', label: '4 MP and larger' },
            { value: '6', label: '6 MP and larger' },
            { value: '8', label: '8 MP and larger' },
            { value: '10', label: '10 MP and larger' },
            { value: '12', label: '12 MP and larger' },
            { value: '15', label: '15 MP and larger' },
            { value: '20', label: '20 MP and larger' }
        ]
    }
};



// WEBPACK FOOTER //
// ./src/presets/searchFilters.js